/* ============
 * Email Send Tracking
 * ============
 *
 * This is the emailSendTracking
 */

import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      id: 0,
      subject: '',
      failed: 0,
      success: 0,
      activeNames: ['1'],
      successContainer: [],
      failedContainer: [],
      loadingSend: false,
    };
  },

  props: {
    emailId: {
      type: Number,
      required: true,
    },

    emailSendTracking: {
      type: Array,
      required: true,
    },

    emailSubject: {
      type: String,
      required: true,
    },

    emailSuccesCount: {
      type: Number,
      required: true,
    },

    emailFailedCount: {
      type: Number,
      required: true,
    },

    emailSendReport: {
      type: Function,
      required: true,
    }
  },

  computed: {
    //
  },

  mounted() {
    this.id = this.emailId;
    this.subject = this.emailSubject;
    this.failed = this.emailFailedCount;
    this.success = this.emailSuccesCount;
    this.successContainer = this.emailSendTracking.filter((item) => { return item.status === 1; });
    this.failedContainer = this.emailSendTracking.filter((item) => { return item.status === 0; });
    if (this.failedContainer.length > 0) {
      this.activeNames = ['2'];
    }
    console.log(this.successContainer);
  },

  watch: {
    //
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    handleChange(val) {
      console.log(val);
    },

    sendReport() {
      this.loadingSend = true;
      let data = [];
      this.failedContainer.forEach(item => {
          data.push({
            'email': item.client_contact.email,
            'name': item.client_contact.first_name+' '+item.client_contact.last_name,
            'Client group': item.client_group.client.client_group.name,
            'List': item.news_subscriber_list.name,
            'Date attempt to sent': item.created_at,
            'error': item.result,
          });
      });
      this.emailSendReport({newsId: this.id, emailErrors: data})
      .then(() => {
        const message = 'Your report is successfully sent';
        this.$message({
          message,
          type: 'success',
        });
        this.loadingSend = false;
      }).catch((e) => {
        this.loadingSend = false;
        console.log(e);
      });
    },
  }
};



// WEBPACK FOOTER //
// ./src/app/components/emailSendTracking/emailSendTracking.js